import { fetchAuthSession } from 'aws-amplify/auth';
import { API_ENDPOINT } from '../config/amplify';

/** The Cognito ID token (API Gateway's Cognito authorizer validates ID tokens). */
export async function getIdToken(): Promise<string> {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString() ?? '';
}

/** Authenticated fetch against the Fly-in Spotter API. */
export async function apiFetch(path: string, options: RequestInit = {}): Promise<Response> {
  const token = await getIdToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...((options.headers as Record<string, string>) ?? {}),
  };
  if (token) headers['Authorization'] = token;
  return fetch(`${API_ENDPOINT}${path}`, { ...options, headers });
}

/** Unwraps the `{ status, data }` envelope, throwing the API message on error. */
export async function apiJson<T>(path: string, options: RequestInit = {}): Promise<T> {
  const res = await apiFetch(path, options);
  const json = (await res.json()) as
    | { status: 'success'; data: T }
    | { status: 'error'; message: string };
  if (json.status === 'error') throw new Error(json.message);
  return json.data;
}
